import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types/news';
import { getCategoryName } from '@/mocks/news';
import { formatViews, timeAgo } from '@/utils/format';

export default function ArticleCard({ article }: { article: NewsArticle }) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link
        to={`/detail/${article.id}`}
        className="relative block h-44 w-full overflow-hidden"
      >
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 911爆料网`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        {article.hot && (
          <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-secondary-500 px-2 py-1 text-xs font-semibold text-background-50">
            <i className="ri-fire-fill"></i>
            热点
          </span>
        )}
      </Link>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center gap-2 text-xs">
          <Link
            to={`/category/${article.category}`}
            className="rounded-md bg-primary-100 px-2 py-1 font-medium text-primary-700 transition-colors hover:bg-primary-200"
          >
            {getCategoryName(article.category)}
          </Link>
          <span className="text-foreground-400">{timeAgo(article.publishedAt)}</span>
        </div>
        <Link to={`/detail/${article.id}`} className="mt-3">
          <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
            {article.title}
          </h3>
        </Link>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {article.summary}
        </p>
        <div className="mt-auto flex items-center gap-4 pt-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(article.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {article.author}
          </span>
        </div>
      </div>
    </article>
  );
}